import { render, staticRenderFns } from "./noMessageWidget.vue?vue&type=template&id=3bff2126&scoped=true"
import script from "./noMessageWidget.vue?vue&type=script&lang=js"
export * from "./noMessageWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff2126",
  null
  
)

export default component.exports